import React from 'react'
import {
  Div, InputWithLabel, Input, P,
} from 'konsys-ui'
import { DatePicker, TimePicker, Select } from 'antd'
import moment from 'moment'
import { checkNotNumber, checkInt } from '../../utils/util-services'

export const TextWithLabelAndUnit = ({ data }) => (
  <Div display='flex' alignItems='flex-end'>
    <Div margin='0 16px 0 0'>
      <P margin='0 0 16px 0' style={{ width: 'max-content' }}>{data.text}</P>
      <P margin='0 0 8px 0'>{data.value}</P>
    </Div>
    <P margin='0 0 8px 0'>{data.unit}</P>
  </Div>
)

export const InputWithLabelAndUnit = ({
  data, onChangeHandler, maxLength, isFloat, margin,
}) => (
  <Div display='flex' alignItems='flex-end' margin={margin}>
    <InputWithLabel {...data.props}
      input={{
        type: isFloat ? 'number' : 'text',
        step: isFloat ? '0.1' : undefined,
        min: '0',
        max: maxLength,
        value: data.value,
        // onKeyDown: (e) => {
        //   if (e.keyCode !== 8
        //     && (
        //       (!_.isUndefined(maxLength)
        //         ? (isFloat && (_.includes(e.target.value, '.') || _.includes([110, 190], e.keyCode)))
        //           ? e.target.value.length >= maxLength + 3
        //           : e.target.value.length >= maxLength
        //         : false
        //       )
        //       || (isFloat && !checkFloat(e)))
        //   ) {
        //     e.preventDefault()
        //   }
        // },
        onKeyDown: e => isFloat && checkNotNumber(e) && e.preventDefault(),
        onChange: e => onChangeHandler(data.id, isFloat ? parseFloat(e.target.value) : e.target.value),
        defaultValue: data.defaultValue,
        disabled: data.disabled,
      }}
    />
    <P margin='0 0 8px 0'>{data.unit}</P>
  </Div>
)

export const InputWithLabelAndUnitOneRow = ({
  data, onChangeHandler, maxLength, isFloat, margin,
}) => (
  <Div display='flex' alignItems='center' margin={margin}>
    <P>{data.props.title.text}</P>
    <Input {...data.props}
      type={isFloat ? 'number' : 'text'}
      step={isFloat ? '0.1' : undefined}
      min='0'
      max={maxLength}
      value={data.value}
      onKeyDown={e => isFloat && checkNotNumber(e) && e.preventDefault()}
      onChange={e => onChangeHandler(data.id, isFloat ? parseFloat(e.target.value) : e.target.value)}
      defaultValue={data.defaultValue}
      disabled={data.disabled}
    />
    <P>{data.unit}</P>
  </Div>
)

export const FloatInput = ({
  data, onChangeHandler, maxLength, isFloat,
}) => (
  <Input {...data.props}
    type={isFloat ? 'number' : 'text'}
    step={isFloat ? '0.1' : undefined}
    min='0'
    max={maxLength}
    value={data.value}
    onKeyDown={e => isFloat && checkNotNumber(e) && e.preventDefault()}
    onChange={e => onChangeHandler(data.id, isFloat ? parseFloat(e.target.value) : e.target.value)}
    defaultValue={data.defaultValue}
    disabled={data.disabled}
    width='100%'
  />
)

export const InputWithLabelBlock = ({
  data, onChangeHandler, maxLength, isFloat, isInt,
}) => (
  <Div display='flex' alignItems='flex-end'>
    <InputWithLabel
      margin='0'
      input={{
        type: isFloat || isInt ? 'number' : 'text',
        step: isFloat
          ? isInt
            ? '1'
            : '0.1'
          : undefined,
        min: '0',
        max: maxLength,
        value: data.value,
        onKeyDown: e => ((isFloat && checkNotNumber(e)) || (isInt && !checkInt(e))) && e.preventDefault(),
        onChange: e => onChangeHandler(data.id, isFloat ? parseFloat(e.target.value) : e.target.value),
        defaultValue: data.defaultValue,
        disabled: data.disabled,
      }}
      {...data.props}
    />
  </Div>
)

export const DatePickerWithLabel = ({ data, onChangeHandler, disabledDate }) => (
  <Div display='flex' flexDirection='column' margin='0'>
    <P margin='0 0 16px'>{data.text}</P>
    <DatePicker
      disabledDate={disabledDate}
      value={moment(data.value).isValid() && moment(data.value)}
      disabled={data.disabled}
      defaultValue={moment(data.defaultValue).isValid() && moment(data.defaultValue)}
      onChange={e => onChangeHandler(data.id, moment(e).format('YYYY-MM-DD'))}
    />
  </Div>
)

export const TimePickerWithLabel = ({ data, onChangeHandler }) => (
  <Div display='flex' flexDirection='column' margin='0'>
    <P margin='0 0 16px'>{data.text}</P>
    <TimePicker
      value={moment(data.value, 'HH:mm').isValid() && moment(data.value, 'HH:mm')}
      disabled={data.disabled}
      style={{ width: '100%' }}
      defaultValue={moment(data.defaultValue, 'HH:mm').isValid() && moment(data.defaultValue, 'HH:mm')}
      format='HH:mm'
      onChange={e => onChangeHandler(data.id, moment(e).format('HH:mm'))}
    />
  </Div>
)

export const DropdownWithLabel = ({
  data, onChangeHandler, options, mappingValueToText,
}) => (
  <Div display='flex' flexDirection='column' margin='0'>
    <P margin='0 0 16px'>{data.text}</P>
    <Select
      value={mappingValueToText(data.value)}
      disabled={data.disabled}
      defaultValue={mappingValueToText(data.defaultValue)}
      placeholder={data.placeholder}
      showSearch
      optionFilterProp="children"
      onChange={e => onChangeHandler(data.id, e)}
      style={{ width: '100%' }}
    >
    {
      options.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
    }
    </Select>
  </Div>
)
